// src/pages/GeneralConditions.js
import React from 'react';
import { useTranslation } from 'react-i18next';
import './style/CGVCGU.css';

function GeneralConditions() {
  const { t } = useTranslation();
  const sections = t('generalconditions.sections', { returnObjects: true });

  return (
    <div className="terms-page">
      <div className="terms-box">
        <h1>{t('generalconditions.title')}</h1>
        <p><em>{t('generalconditions.lastUpdate')}</em></p>

        {Object.keys(sections).map((key) => (
          <section key={`legal-${key}`}>
            <h2>{sections[key].title}</h2>
            {Array.isArray(sections[key].text) ? (
              <ul>
                {sections[key].text.map((item, idx) => (
                  <li key={idx}>{item}</li>
                ))}
              </ul>
            ) : (
              <p>{sections[key].text}</p>
            )}
          </section>
        ))}
      </div>
    </div>
  );
}

export default GeneralConditions;
